import ProtectedComponent from 'hoc/ProtectedComponent';
import styled from 'styled-components';
import { ANNOTATION_UPDATE } from 'constants/capabilities';

const EditNoteStyle = styled.i`
    font-size: 18px;
    vertical-align: middle;
    color: ${props => (props.iconColor || '#337ab7')};
    cursor: pointer;
`;

const EditNoteButton = ProtectedComponent({ requiredCapabilities: [ANNOTATION_UPDATE] })(EditNoteStyle);

export default EditNoteButton;



// WEBPACK FOOTER //
// ./src/components/molecules/buttons/EditNoteButton.js